
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/panels/messagePanels/publishingBlocked/publishingBlockedForUser.scss.css.virtualfile';
        module.exports = {"root":"_root_1uq9z_1"};